export default __webpack_public_path__ + "static/media/IconDesc_Snow.256.eda60896.png";